interface Window {
  phpProps: object;
  videojs: Function;
}
const am = {
  mobileThresh: 1120,
  scrollThresh: 100,
  adDelay: 3000,
  domReadyRan: false,
  checkUserStaff: false,
  isDevDomain: false,
  isSingle: false,
  isMobileDevice: false,
  isMobileWidth: false,
  setupShareRan: false,
  constructor() {
    am.importPropsPHP();
    am.detectMobileWidth();
    am.detectMobileDevice();
    window.addEventListener('resize', am.detectMobileWidth);
    am.domReady(() => {
      if (!am.domReadyRan) {
        am.disqusCountObserver();
        if (am.checkUserStaff) am.checkCriticalElements();
        am.setupMenu();
        am.detectThresh();
        am.setupBreakingAlerts();
        am.setupLiveTrialLoader();
        am.setupShare();
        am.setupCopyLink();
        am.insertChatIntoVideoPost();
        if (am.isSingle) am.pChecker();
        if (am.isSingle) am.pCounter();
        am.setupLazyLoader();
        am.generateNewsKeywords();
        am.wrapVideoIframes();
       am.cleanupPostContentForTaboola();
      }
      am.domReadyRan = true;
    });
  },
  checkCriticalElements() {
    const criticalElements = {
      'Comscore': document.querySelector('#comscore'),
      'Quantcast': document.querySelector('#quantcast')
    };
    for (const key in criticalElements) {
      if (!criticalElements[key]) {
        alert('WARNING: ' + key + ' is missing! Please contact a developer.');
      }
    }
  },
  checkNavBar() {
    const body = document.body;
    const navbar = document.querySelector('.c-header-nav-bar')!;
    const navbarLinks = document.querySelectorAll('.c-header-nav-bar__link');
    const isScrolled = body.classList.contains('is-scrolled');
    const isMobileSize = body.classList.contains('is-mobile-width');
    const hasClosedMenu = body.classList.contains('has-closed-menu');
    if (isScrolled || isMobileSize || !hasClosedMenu) {
      navbar.classList.add('is-collapsed');
      navbarLinks.forEach(el => el.setAttribute('tabindex', '-1'));
    } else {
      navbar.classList.remove('is-collapsed');
      navbarLinks.forEach(el => el.removeAttribute('tabindex'));
    }
  },
  detectMobileDevice() {
    const isMobileDevice = !!navigator.userAgent.match(/mobi/i);
    if (isMobileDevice) {
      am.domReady(() => document.body.classList.add('is-mobile-device'));
      am.log('mobile browser detected');
    } else am.log('not a mobile browser');
    am.isMobileDevice = isMobileDevice;
    return isMobileDevice;
  },
  detectMobileWidth() {
    const isMobileWidth = window.innerWidth <= am.mobileThresh;
    if (isMobileWidth) {
      am.domReady(() => document.body.classList.add('is-mobile-width'));
      am.log('mobile width detected');
    } else am.log('not mobile width');
    am.isMobileWidth = isMobileWidth;
    return isMobileWidth;

  },
  detectThresh() {

    // Setup =====================================================================

    const body = document.body;
    const widthThresh = 1140;
    const scrollThreshClass = 'is-scrolled';
    const widthThreshClass = 'is-mobile-width';

    // Tests
    const isBeyondScrollThresh = () => window.scrollY >= am.scrollThresh;
    const isBeyondWidthThresh = () => window.innerWidth >= widthThresh;

    // Results
    const threshCrossed = {
      scroll: isBeyondScrollThresh(),
      width: isBeyondWidthThresh()
    };

    // Functions =================================================================

    function initCheck() {
      if (threshCrossed.scroll) body.classList.add(scrollThreshClass);
      else body.classList.remove(scrollThreshClass);
      if (threshCrossed.width) body.classList.remove(widthThreshClass);
      else body.classList.add(widthThreshClass);
      am.checkNavBar();
    }

    function eventCheck(threshTest, threshType, threshStateClass) {
      const beyondThresh = threshTest();
      const crossingBeyond = beyondThresh && !threshCrossed[threshType];
      const crossingWithin = !beyondThresh && threshCrossed[threshType];
      if (crossingBeyond || crossingWithin) {
        threshCrossed[threshType] = !threshCrossed[threshType];
        am.log(threshCrossed);
        body.classList.toggle(threshStateClass);
        am.checkNavBar();
      }
    }

    // Actions ===================================================================

    initCheck();
    window.addEventListener('scroll',
      eventCheck.bind(am, isBeyondScrollThresh, 'scroll', scrollThreshClass)
    );
    window.addEventListener('resize',
      eventCheck.bind(am, isBeyondWidthThresh, 'width', widthThreshClass)
    );
  },
  disqusCountObserver() {
    const links = document.querySelectorAll('.u-disqus-count');
    if (links.length && 'MutationObserver' in window) {
      links.forEach(link => link.classList.add('u-disqus-count-facade'));
      const replace = link => {
        const count = parseInt(link.innerText.match(/\d+/));
        const text = count === 1 ? 'comment' : 'comments';
        link.classList.remove('u-disqus-count-facade', 'u-disqus-count');
        if (count === 0 || isNaN(count)) link.classList.add('u-comment-cta');
        else {
          link.innerHTML = `
            <span class="comment-num">${count}</span>
            <span class="comment-text">${text}</span>
          `;
        }
      };
      const handleMutation = (mutationsList, observer) => {
        setTimeout(() => {
          links.forEach(link => replace(link));
          observer.disconnect();
        }, 100);
      };
      const observer = new MutationObserver(handleMutation);
      const config = {
        childList: true,
        subtree: false
      };
      observer.observe(links[0], config);
      setTimeout(loadDisqusCount, 1000);
      setTimeout(cleanupFacades, 6000);
    } else {
      setTimeout(cleanupFacades);
      setTimeout(loadDisqusCount, 1000);
    }

    function cleanupFacades() {
      document.querySelectorAll<HTMLElement>('.u-disqus-count-facade').forEach(facade => {
        facade.style.backgroundColor = '#fff';
      });
    }

    function loadDisqusCount() {
      const scriptEl = document.createElement('script');
      scriptEl.src = `//lawnewz.disqus.com/count.js`;
      scriptEl.id = 'dsq-count-scr';
      scriptEl.async = true;
      const firstScriptEl = document.getElementsByTagName('script')[0];
      const parentEl = firstScriptEl.parentNode!;
      parentEl.insertBefore(scriptEl, firstScriptEl);
    }

  },
  domReady(callback) {
    const stillLoading = document.readyState === 'loading';
    if (stillLoading) document.addEventListener('DOMContentLoaded', callback);
    else callback();
  },
  generateNewsKeywords() {
    const keywordsMeta = document.querySelector<HTMLMetaElement>('meta[name=keywords]');
    if (keywordsMeta) {
      const newsKeywordsMeta = document.createElement('meta');
      newsKeywordsMeta.name = 'news_keywords';
      newsKeywordsMeta.content = keywordsMeta.content;
      const keywordsMetaParent = keywordsMeta.parentNode!;
      keywordsMetaParent.insertBefore(newsKeywordsMeta, keywordsMeta);
    }
  },
  group(message: string, ...styles: string[]) {
    const notDisabledOnDev = am.isDevDomain && am.urlParams['debug'] !== 'off';
    const enabledOnProd = am.urlParams['debug'] === 'on';
    if (notDisabledOnDev || enabledOnProd) {
      // eslint-disable-next-line no-console
      console.group(message, ...styles);
    }
  },
  groupEnd() {
    const notDisabledOnDev = am.isDevDomain && am.urlParams['debug'] !== 'off';
    const enabledOnProd = am.urlParams['debug'] === 'on';
    if (notDisabledOnDev || enabledOnProd) {
      // eslint-disable-next-line no-console
      console.groupEnd();
    }
  },
  getWinThresh(minThresh: number, fullThresh: number) {
    const width = window.innerWidth;
    let size;
    if (width >= minThresh && width <= fullThresh) {
      size = 'medium';
    } else if (width > fullThresh) {
      size = 'full';
    } else if (width < minThresh) {
      size = 'small';
    } else {
      size = 'unknown';
    }
    am.log('Window Thresh is: ' + size);
    return size;
  },
  importPropsPHP() {
    for (const prop in window.phpProps) {
      if (Object.prototype.hasOwnProperty.call(window.phpProps, prop)) {
        am[prop] = window.phpProps[prop];
      }
    }
  },
  insertChatIntoVideoPost() {
    if (am.postHasVideo()) {
      const target = document.querySelector('#sidebar-hook-1');
      if (target) {
        const chatSrc = '//chatroll.com/embed/chat/law-crime-network?id=dp_9fir_vqF';
        const chatElement = () => {
          const element = document.createElement('iframe');
          element.classList.add('c-chat', 'c-sidebar-chat');
          element.setAttribute('src', chatSrc);
          return element;
        };
        target.parentNode!.insertBefore(chatElement(), target);
      }
    }
  },
  loadScript(uri: string, onloadCallback, onerrorCallback: OnErrorEventHandler) {
    const scriptEl = document.createElement('script');
    scriptEl.src = uri;
    scriptEl.async = true;
    if (typeof onloadCallback === 'function') scriptEl.onload = onloadCallback;
    if (typeof onerrorCallback === 'function') scriptEl.onerror = onerrorCallback;
    const firstScriptEl = document.getElementsByTagName('script')[0];
    firstScriptEl.parentNode!.insertBefore(scriptEl, firstScriptEl);
  },
  loadAsset(filename: string, callback: Function | undefined = undefined) {
    const fileExtensions = filename.match(/\.[0-9a-z]+$/i);
    if (!fileExtensions) {
      am.log(`No file extension found for asset ${filename}`);
      return;
    }
    const fileExtension = fileExtensions[0];
    let element;
    if (fileExtension === '.js') {
      // Check if already added
      const existingScriptElement = document.querySelector(`script[src="${filename}"]`);
      if (existingScriptElement !== null) {
        am.log('Script already added');
        if (callback) element.onload = () => callback();
        return;
      }
      // Add to document head
      element = document.createElement('script');
      element.setAttribute('async', true);
      element.setAttribute('src', filename);
      if (callback) element.onload = callback;
    } else if (fileExtension === '.css') {
      // Check if already linked
      const existingLinkElement = document.querySelector(`link[href="${filename}"]`);
      if (existingLinkElement !== null) {
        am.log('Stylesheet already linked');
        return;
      }
      // Add to document head
      element = document.createElement('link');
      element.setAttribute('rel', 'stylesheet');
      element.setAttribute('type', 'text/css');
      element.setAttribute('href', filename);
    }
    if (typeof element !== 'undefined') {
      document.getElementsByTagName('head')[0].appendChild(element);
    }
  },
  log(message: (string | object), ...styles: (string | undefined)[]) {
    const notDisabledOnDev = am.isDevDomain && am.urlParams['debug'] !== 'off';
    const enabledOnProd = am.urlParams['debug'] === 'on';
    if (notDisabledOnDev || enabledOnProd) {
      // eslint-disable-next-line no-console
      console.log(message, ...styles);
    }
  },
  maxHeader() {
    const header = document.querySelector('header')!;
    if (header.classList.contains('compact')) {
      am.log('maximizing header');
      header.classList.remove('compact');
      header.classList.add('full');
    }
  },
  minHeader() {
    const header = document.querySelector('header')!;
    if (header.classList.contains('full')) {
      am.log('minimizing header');
      header.classList.remove('full');
      header.classList.add('compact');
    }
  },
  pChecker() {
    const postBody = document.querySelector('.o-post-wrap')!;
    postBody.querySelectorAll('p').forEach(p => {
      if (!p.innerText) p.classList.add('o-no-text');
    });
  },
  pCounter() {
    const pHook = '#post-body > p';
    const paragraphs = document.querySelectorAll(pHook);
    const frequency = 1;
    const log = false;
    const charMinimum = 100;
    const paragraphsTruncated = 3;
    let candidateCount = 0;
    let qualifiedCount = 0;
    let pCount = 0;
    for (let i = 0; i < paragraphs.length - paragraphsTruncated; i++) {
      pCount = i + 1;
      const thisParagraph = pHook + ':nth-of-type(' + pCount + ')';
      const thisParagraphEl = document.querySelector(thisParagraph)!;
      if (log) console.log(thisParagraphEl);
      const thisParagraphContent = thisParagraphEl.textContent;
      if (thisParagraphContent) {
        const charsInParagraph = thisParagraphContent.length;
        if (log) console.log('p:' + pCount + ' - ' + charsInParagraph + ' characters');
        if (charsInParagraph > charMinimum) {
          candidateCount++;
          if (log) console.log('p:' + pCount + ' - has qualified. ' + candidateCount + ' paragraph' + (candidateCount == 1 ? ' has' : 's have') + ' now qualified');
          if (candidateCount % frequency == 0) {
            qualifiedCount++;
            thisParagraphEl.classList.add(`qualified`, `qualified-${qualifiedCount}`);
          }
        }
      }
    }
  },
  populateGet() {
    const obj = {}, params = location.search.slice(1).split('&');
    for (let i = 0, len = params.length;i < len;i++) {
      const keyVal = params[i].split('=');
      obj[decodeURIComponent(keyVal[0])] = decodeURIComponent(keyVal[1]);
    }
    am.log(obj);
    return obj;
  },
  postHasVideo() {
    // Check for video embed in posts
    const vjsEmbed = document.querySelector('#post-body .video-js');
    const jwEmbed = document.querySelector('#post-body .jwvideo');
    const lsEmbed = document.querySelector('#post-body iframe[id^=\'ls_embed\']');
    const ooEmbed = document.querySelector('#post-body iframe.stream-embed');
    const ipEmbed = document.querySelector('#post-body .inplayer-paywall');
    if (jwEmbed || lsEmbed || ooEmbed || ipEmbed || vjsEmbed) return true;
    else return false;
  },
  cleanupPostContentForTaboola() {
    // Get the post body container
    const postBody = document.getElementById('post-body');
    if (!postBody) return;

    // Get all children
    const children = Array.from(postBody.children);
    
    // Process paragraphs from the end until we hit meaningful content
    // This ensures we only remove empty paragraphs at the end of the post
    for (let i = children.length - 1; i >= 0; i--) {
      const element = children[i];
      
      // Only process paragraphs - stop if we hit any other element type
      if (element.tagName !== 'P') break;
      
      // Check if the paragraph has any text content or embedded media
      const hasText = element.textContent?.trim();
      const hasEmbeds = element.querySelector('iframe, img, video, embed');
      
      if (!hasText && !hasEmbeds) {
        element.remove();
      } else {
        // Stop when we hit any non-empty content
        break;
      }
    }
    
    // After cleanup, handle callout positioning
    const updatedChildren = Array.from(postBody.children);
    const lastElement = updatedChildren[updatedChildren.length - 1];
    if (!lastElement?.classList?.contains('o-callout')) return;
    
    // Find a substantial paragraph (100+ chars) to place the callout before
    let insertIndex = -1;
    for (let i = updatedChildren.length - 2; i >= 0; i--) {
      const element = updatedChildren[i];
      if (element.tagName === 'P' && element.textContent.length >= 100) {
        insertIndex = i;
        break;
      }
    }
    
    // Move the callout if we found a suitable location
    if (insertIndex !== -1) {
      const targetElement = updatedChildren[insertIndex];
      targetElement.parentNode.insertBefore(lastElement, targetElement);
    }
  },
  setupBreakingAlerts() {
    const button = document.querySelector('.c-close-breaking-alert-btn');
    if (button) {
      button.addEventListener('click', () => {
        document.querySelector('.c-breaking-alert')!.classList.add('is-collapsed');
      });
    }
  },
  setupCopyLink() {
    const copyButton = document.querySelector<HTMLElement>('#copy-button');
    if (copyButton) {
      const copyUrl = copyButton.dataset.copyUrl;
      if (copyUrl) {
        const clickHandler = () => {
          navigator.clipboard.writeText(copyUrl);
          copyButton.classList.add('is-copied');
        };
        const transititonendHandler = () => {
          copyButton.classList.remove('is-copied');
        };
        copyButton.addEventListener('click', clickHandler);
        copyButton.addEventListener('transitionend', transititonendHandler);
      }
    }
  },
  setupLazyLoader() {

    // Setup ===================================================================

    const buffer = 50; // px
    const lazyParentClass = '.u-lazy-parent';
    const lazyChildClass = '.u-lazy-child';

    const lazyParents = document.querySelectorAll(lazyParentClass);
    const observable = 'IntersectionObserver' in window;
    const nativelyObservable = observable ? (/\{\s*\[native code\]\s*\}/).test('' + IntersectionObserver) : 0;


    // Behavior ===============================================================

    if (nativelyObservable) {
      const options = {
        root: null,
        rootMargin: buffer + 'px',
        threshold: 0
      };
      const observer = new IntersectionObserver(observationCallback, options);
      lazyParents.forEach(element => observer.observe(element));
    } else {
      lazyParents.forEach(element => {
        const lazyListener = () => lazyChecker(lazyListener, element as HTMLElement);
        window.addEventListener('scroll', lazyListener);
        lazyListener();
      });
    }


    // Functions ================================================================

    function lazyLoad(lazyParent: HTMLElement) {
      const lazyChildren = lazyParent.querySelectorAll(lazyChildClass);
      lazyChildren.forEach(lazyChild => {
        if (lazyChild.firstChild && lazyChild.firstChild.textContent) {
          lazyChild.insertAdjacentHTML('afterend', lazyChild.firstChild.textContent);
        }
        lazyChild.remove();
      });
    }

    function observationCallback(entries: IntersectionObserverEntry[], observer: IntersectionObserver) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          lazyLoad(entry.target as HTMLElement);
          observer.unobserve(entry.target);
          const id = entry.target.id || 'no id';
          am.log('%cLazy Observation Activated%c for%c ' + id, 'color: lime;', 'color: inherit;', 'color: PapayaWhip;');
        }
      });
    }

    function lazyChecker(listener: EventListener, lazyParent: HTMLElement) {
      const loadPoint = lazyParent.offsetTop - buffer;
      const bottomOfWindow = window.scrollY + window.innerHeight;
      if (bottomOfWindow >= loadPoint) {
        window.removeEventListener('scroll', listener);
        lazyLoad(lazyParent);
        am.log('%cLazy Check Activated%c for%c ' + lazyParent.id, 'color: gold;', 'color: inherit;', 'color: PapayaWhip;');
      }
    }
  },
  setupLiveTrialLoader() {

    // Todo
    // control aspect ratio on window resize
    // only allow one swap per post

    const streamSection = document.querySelector('.c-stream-section');
    const playerId = 'lnc-stream';
    const stateClassName = 'is-selected-stream';
    const siteHeader = document.querySelector('#header-content')!;
    const poster = 'https://am22.mediaite.com/lc/cnt/uploads/2020/05/lnc-poster-720.jpg';
    const videoJsCss = 'https://vjs.zencdn.net/7.7.6/video-js.css';
    const videoJsScript = 'https://vjs.zencdn.net/7.7.6/video.js';
    const videoElement = document.querySelector('.c-stream')!;
    const liveFeedItems = document.querySelectorAll('.o-live-feed-item');

    if (streamSection !== null) {

      const iframeComponent = videoSrc => {
        const element = document.createElement('div');
        const iframe = document.createElement('iframe');
        element.classList.add('o-stream-feed-iframe-wrap', 'u-responsive-16x9-iframe-wrap');
        iframe.setAttribute('width', '100%');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('height', window.innerWidth * 0.5625 + 'px');
        iframe.setAttribute('src', videoSrc);
        iframe.classList.add('c-feed-stream');
        element.appendChild(iframe);
        return element;
      };

      const videojsComponent = () => {
        const element = document.createElement('video');
        element.classList.add('video-js', 'vjs-fluid', 'vjs-big-play-centered');
        element.setAttribute('id', playerId);
        element.setAttribute('controls', '');
        element.setAttribute('playsinline', '');
        element.setAttribute('autoplay', '');
        element.setAttribute('data-setup', '{}');
        element.setAttribute('poster', poster);
        return element;
      };

      const removeVideos = () => {
        const inplayerPaywall = document.querySelector('.inplayer-paywall');
        const iframe = document.querySelector('.o-stream-feed-iframe-wrap');
        const katapyPaywall = document.querySelector('.katapy-container');
        const videojsElement = document.getElementById(playerId);
        if (katapyPaywall !== null) katapyPaywall.remove();
        if (inplayerPaywall !== null) inplayerPaywall.remove();
        if (iframe !== null) iframe.remove();
        if (videojsElement !== null) window.videojs(videojsElement).dispose();
      };

      const handleClick = (event, videoTypeAttr, videoSrcAttr) => {
        event.preventDefault();
        const top = window.pageYOffset + streamSection.getBoundingClientRect().top - siteHeader.clientHeight;
        window.scrollTo(0, top);
        removeVideos();
        let clickedLink;
        let currentNode = event.target;
        while (currentNode !== document.body) {
          const foundLink = !!currentNode.href;
          if (foundLink) {
            clickedLink = currentNode;
            break;
          } else {
            currentNode = currentNode.parentNode;
          }
        }
        if (videoTypeAttr.nodeValue === 'playlist') {
          am.loadAsset(videoJsCss);
          am.loadAsset(videoJsScript, () => {
            videoElement.appendChild(videojsComponent());
            window.videojs(playerId).src(videoSrcAttr.nodeValue);
          });
        } else if (videoTypeAttr.nodeValue === 'iframe') {
          videoElement.prepend(iframeComponent(videoSrcAttr.nodeValue));
        }
        liveFeedItems.forEach(link => link.classList.remove(stateClassName));
        clickedLink.classList.add(stateClassName);
      };

      liveFeedItems.forEach(item => {
        const videoTypeAttr = item.attributes.getNamedItem('data-video-type');
        const videoSrcAttr = item.attributes.getNamedItem('data-video-src');
        if (videoTypeAttr && videoSrcAttr) {
          item.addEventListener('click', () => {
            handleClick(event, videoTypeAttr, videoSrcAttr);
          });
        }
      });
    }
  },
  setupMenu() {
    const menu = document.querySelector('#menu')!;
    const menuBtn = document.querySelector('#menu-btn')!;
    const menuCloseModal = document.createElement('div');
    const menuFocusBreaks = document.querySelectorAll('.u-menu-focus-break');
    const handleMenuFocusBreak = () => {
      document.body.classList.add('has-closed-menu');
      menu.classList.add('is-closed-menu');
      menuCloseModal.classList.add('is-closed-menu-modal');
    };
    document.body.classList.add('has-closed-menu');
    menuCloseModal.id = 'menu-close-modal';
    menuCloseModal.classList.add('o-menu-close-modal');
    menuCloseModal.classList.add('c-menu-close-modal');
    menuCloseModal.classList.add('is-closed-menu-modal');

    menuBtn.addEventListener('click', toggleMenu);
    menuCloseModal.addEventListener('click', toggleMenu);

    function toggleMenu() {
      document.body.classList.toggle('has-closed-menu');
      am.checkNavBar();
      menu.classList.toggle('is-closed-menu');
      menuCloseModal.classList.toggle('is-closed-menu-modal');
    }
    document.body.appendChild(menuCloseModal);
    menuFocusBreaks.forEach(el => {
      el.addEventListener('focus', handleMenuFocusBreak);
    });
  },
  setupShare() {

    const btn = document.querySelector('.o-share-btn');

    const facebookScript = () => {
      (function() {
        if (document.getElementById('facebook-jssdk')) return;
        const fjs = document.getElementsByTagName('script')[0];
        const js = document.createElement('script');
        js.id = 'facebook-jssdk';
        js.src = '//connect.facebook.net/en_US/all.js#xfbml=1';
        fjs.parentNode!.insertBefore(js, fjs);
      }());
    };

    const handleClick = () => {
      if (!am.setupShareRan) {
        facebookScript();
        am.loadAsset('https://platform.twitter.com/widgets.js');
      }
      const shareItems = document.querySelectorAll('.o-share-item');
      shareItems.forEach(shareItem => {
        shareItem.classList.toggle('is-collapsed');
      });
      am.setupShareRan = true;
    };
    const handleMouseEnter = () => {
      if (!am.setupShareRan) {
        facebookScript();
        am.loadAsset('https://platform.twitter.com/widgets.js');
      }
      am.setupShareRan = true;
    };
    if (btn) {
      btn.addEventListener('mouseenter', () => handleMouseEnter());
      btn.addEventListener('click', () => handleClick());
    }
  },
  wrapVideoIframes() {
    if (!document.body.classList.contains('is-home')) {
      const youtube = document.querySelectorAll('iframe[src*="youtube"]');
      const facebook = document.querySelectorAll('iframe[src*="facebook"]');
      if (youtube || facebook) {
        const addWrapper = element => {
          const responsiveWrap = document.createElement('div');
          responsiveWrap.classList.add('u-responsive-16x9-iframe-wrap');
          element.parentNode.insertBefore(responsiveWrap, element);
          responsiveWrap.appendChild(element);
        };
        youtube.forEach(element => addWrapper(element));
        facebook.forEach(element => addWrapper(element));
      }
    }
  },
  get urlParams() {
    const parsedParams = {};
    const urlParams = location.search.slice(1).split('&');
    urlParams.forEach(keyValString => {
      const keyValArray = keyValString.split('=');
      const key = decodeURIComponent(keyValArray[0]);
      const val = decodeURIComponent(keyValArray[1]);
      parsedParams[key] = val;
    });
    return parsedParams;
  }
};
am.constructor();
